import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";

function BootCampMember({ close, participants }) {
    return (
        <div className="AddnewsupportTicket relative min-w-[48.3rem]">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center pb-10">
                شرکت کنندگان
            </p>
            <div className=" max-h-[50.6rem] ">
                {participants?.map((item, index) => (
                    <p className=" text-[#21212199] text-[1.8rem] font-normal leading-[3.2rem] mb-[0.9rem]">
                        <span>{index + 1}- </span> {item.username} (
                        {item.get_roll_type_display})
                    </p>
                ))}
            </div>
        </div>
    );
}

export default BootCampMember;
